export function htmlToReact(html) {
    // Por algum cazzo diabólico maluco, as tags <i></i> não são renderizadas para
    // itálico. Precisamos convertar React em HTML ou coisa que o valha.
    // https://www.npmjs.com/package/html-to-react
    var HtmlToReactParser = require('html-to-react').Parser;	
    var htmlToReactParser = new HtmlToReactParser();

    return (htmlToReactParser.parse(html));
}